export default "__VITE_ASSET__CoUxnsEM__"